import React, { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default marker icon in Leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "/pin-icon.svg",
  iconUrl: "/pin-icon.svg",
  shadowUrl: undefined,
});

const icon = L.icon({
  iconUrl: "/pin-icon.svg",
  iconSize: [38, 38],
  iconAnchor: [19, 38],
});

// Helga Jakobs Immobilien, Eschweiler coordinates
const defaultCenter: [number, number] = [50.8128, 6.216];
const defaultZoom = 15;

interface ResetCenterViewProps {
  coordinates: { lat: number; lng: number } | null;
  city: string;
}

function ResetCenterView({ coordinates, city }: ResetCenterViewProps) {
  const map = useMap();

  useEffect(() => {
    if (!city || !coordinates) {
      return;
    }

    // Only fly to location if we have valid coordinates
    if (
      typeof coordinates.lat === "number" &&
      typeof coordinates.lng === "number" &&
      !isNaN(coordinates.lat) &&
      !isNaN(coordinates.lng)
    ) {
      setTimeout(() => {
        map.flyTo(L.latLng(coordinates.lat, coordinates.lng), 15, {
          animate: true,
          duration: 1.5,
        });
      }, 300);
    }
  }, [coordinates, city, map]);

  return null;
}

interface PropertyMapProps {
  coordinates: { lat: number; lng: number } | null;
  city: string;
}

const PropertyMap: React.FC<PropertyMapProps> = ({ coordinates, city }) => {
  const locationSelection: [number, number] | null =
    coordinates &&
    typeof coordinates.lat === "number" &&
    typeof coordinates.lng === "number" &&
    !isNaN(coordinates.lat) &&
    !isNaN(coordinates.lng)
      ? [coordinates.lat, coordinates.lng]
      : null;

  return (
    <MapContainer
      center={defaultCenter}
      zoomControl={false}
      zoom={defaultZoom}
      style={{ width: "100%", height: "100%", zIndex: 0 }}
      className=""
      // @ts-ignore - Leaflet types issue
    >
      <TileLayer
        // @ts-ignore - Leaflet types issue
        attribution='&copy; <a className="hidden" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://tile.jawg.io/dfbe15c6-374e-4f04-92c0-5c9678cd7132/{z}/{x}/{y}{r}.png?access-token=aIs4QlE6wRbH35AB9YspWkO82STp4zrWRwcuEkmwWFgJ4WhsEqThj2fsGhCT7g7w"
      />
      {/* Always show default marker for Helga Jakobs Immobilien */}
      <Marker
        position={defaultCenter}
        // @ts-ignore - Leaflet types issue
        icon={icon}
      >
        <Popup>Helga Jakobs Immobilien, Eschweiler</Popup>
      </Marker>
      {/* Show property marker if address is selected */}
      {locationSelection &&
        city &&
        locationSelection[0] !== defaultCenter[0] &&
        locationSelection[1] !== defaultCenter[1] && (
          <Marker
            position={locationSelection}
            // @ts-ignore - Leaflet types issue
            icon={icon}
          >
            <Popup>{city}</Popup>
          </Marker>
        )}
      <ResetCenterView coordinates={coordinates} city={city} />
    </MapContainer>
  );
};

export default PropertyMap;
